
import {SET_MODAL_INFO} from '../actions/_CONSTANTS';

const modalInfo = (state={}, action) => {
  switch(action.type){
    case SET_MODAL_INFO:
      return action.payload;
    default:
      return state;
  }
}

export default modalInfo;